function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", {
  id: "defs915"
});

var SvgMvIcon = function SvgMvIcon(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    style: {
      enableBackground: "new 0 0 90 90"
    },
    viewBox: "0 0 90 90",
    y: "0px",
    x: "0px",
    fill: "#000000",
    width: "100px",
    height: "100px",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, /*#__PURE__*/React.createElement("g", {
    id: "g198",
    transform: "matrix(1.2530337,0,0,1.2530337,-11.71591,-15.534417)",
    style: {
      fill: "none",
      stroke: "#ffffff",
      strokeOpacity: 1
    }
  }, /*#__PURE__*/React.createElement("polygon", {
    transform: "translate(0.66176471,3.3088235)",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      stroke: "#ffffff",
      strokeOpacity: 1
    },
    id: "polygon186",
    points: "51.58429,64.57428 50.33429,69.254272 52.904297,69.254272 54.684326,64.57428 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      stroke: "none",
      strokeOpacity: 1
    },
    id: "path188",
    d: "M 61.766074,46.873094 H 29.556052 c -2.899964,0 -5.25,2.359985 -5.25,5.25 0,2.900024 2.350036,5.260009 5.25,5.260009 h 32.210022 c 2.899963,0 5.26001,-2.359985 5.26001,-5.260009 0,-2.890015 -2.360047,-5.25 -5.26001,-5.25 z m -11.380005,6.25 h -14.98999 v -2 h 14.98999 z m 5.549988,0 h -3.529969 v -2 h 3.529969 z"
  }), /*#__PURE__*/React.createElement("polygon", {
    transform: "translate(0.66176471,3.3088235)",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      stroke: "#ffffff",
      strokeOpacity: 1
    },
    id: "polygon190",
    points: "46.004272,64.57428 46.004272,69.254272 48.264282,69.254272 49.514282,64.57428 "
  }), /*#__PURE__*/React.createElement("polygon", {
    transform: "translate(0.66176471,3.3088235)",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      stroke: "#ffffff",
      strokeOpacity: 1
    },
    id: "polygon192",
    points: "44.004272,64.57428 40.484314,64.57428 41.734314,69.254272 44.004272,69.254272 "
  }), /*#__PURE__*/React.createElement("polygon", {
    transform: "translate(0.66176471,3.3088235)",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      stroke: "#ffffff",
      strokeOpacity: 1
    },
    id: "polygon194",
    points: "39.664307,69.254272 38.414307,64.57428 35.31427,64.57428 37.094299,69.254272 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#ffffff",
      strokeOpacity: 1
    },
    id: "path196",
    d: "M 72.246054,40.553086 H 69.216086 V 34.97313 c 0,-2.800049 -2.280029,-5.070007 -5.070007,-5.070007 h -0.799988 l 3.139954,-3.660034 c 0.550048,0.130005 1.110046,0.220031 1.670043,0.220031 1.979981,0 3.959961,-0.830017 5.349976,-2.450012 1.219971,-1.419983 1.809998,-3.23999 1.669983,-5.109985 -0.139954,-1.880005 -1.01001,-3.580017 -2.429993,-4.809998 -1.429992,-1.220032 -3.25,-1.820007 -5.119995,-1.670044 -1.869995,0.140015 -3.580017,1 -4.799988,2.430054 -1.22998,1.429993 -1.820007,3.23999 -1.679992,5.119995 0.06,0.759949 0.23999,1.48999 0.519958,2.169983 l -5.539978,6.460022 -1.109985,1.299988 H 36.306052 l -1.119995,-1.299988 -5.539978,-6.460022 c 0.98999,-2.380005 0.640014,-5.210022 -1.140015,-7.289978 -2.530029,-2.950012 -6.97998,-3.290039 -9.929993,-0.76001 -1.419983,1.229981 -2.289978,2.929993 -2.429992,4.809998 -0.140015,1.869995 0.450012,3.690002 1.679992,5.109985 1.390015,1.619995 3.359986,2.450012 5.339966,2.450012 0.559998,0 1.120056,-0.09003 1.670044,-0.220031 l 0.440002,0.510009 2.699952,3.150025 h -0.799988 c -2.789978,0 -5.070007,2.269958 -5.070007,5.070007 v 5.579956 h -3.029969 c -2.190002,0 -3.97998,1.78003 -3.97998,3.980042 V 59.97313 c 0,2.190003 1.789978,3.979981 3.97998,3.979981 h 5.369995 c 0.52002,11.260009 9.820008,20.270019 21.219971,20.270019 11.390015,0 20.690002,-9.01001 21.220032,-20.270019 h 5.359985 c 2.190003,0 3.979981,-1.789978 3.979981,-3.979981 V 44.533128 c 0,-2.200012 -1.789978,-3.980042 -3.979981,-3.980042 z m -9.47998,-16.609985 c 0.25,0.289978 0.51001,0.570007 0.809997,0.830017 0.299988,0.26001 0.630005,0.47998 0.960022,0.679993 l -2.700012,3.150024 -1.119995,1.299988 h -3.070007 z m -35.970032,1.51001 c 0.320007,-0.200013 0.650024,-0.419983 0.950012,-0.679993 0.299988,-0.26001 0.559998,-0.540039 0.809998,-0.830017 l 5.119995,5.960022 H 30.616049 Z M 54.946067,74.563096 H 36.376059 L 33.076071,65.883103 H 58.246054 Z M 74.226035,59.97313 c 0,1.089966 -0.889954,1.979981 -1.979981,1.979981 H 24.446067 19.076071 c -1.090026,0 -1.97998,-0.890015 -1.97998,-1.979981 V 44.533128 c 0,-1.090027 0.889954,-1.980042 1.97998,-1.980042 h 53.169983 c 1.090027,0 1.979981,0.890015 1.979981,1.980042 z"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgMvIcon, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/mv_icon.a28443f4.svg";
export { ForwardRef as ReactComponent };